import React, { useState } from "react";
import { toast } from "sonner";
import { Download, Loader2, Play, Sparkles } from "lucide-react";
import { api, assetUrl, errMsg } from "../../lib/api";
import { secs } from "../../hooks/useVideoStudio";

const mb = (b) => `${((b || 0) / 1048576).toFixed(1)} MB`;

export const ExportCard = ({ video, onChange, onWatch, beforeMake }) => {
  const [busy, setBusy] = useState(false);
  const ex = video.export || {};
  const rendering = ex.status === "rendering";
  const hasReady = video.clips.some((c) => c.status === "ready");
  const make = async () => {
    setBusy(true);
    try {
      if (!(await beforeMake())) return;
      onChange(await api.exportVideo(video.id));
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="export-card">
      <div className="flex-1 min-w-0">
        <h3 className="text-sm font-medium text-slate-900">Finished video <span className="text-[11px] font-normal text-slate-400">free · MP4</span></h3>
        <p className="text-xs text-slate-500 mt-0.5" data-testid="export-status">
          {rendering ? "Joining clips, adding captions and music…"
            : ex.status === "ready" ? (ex.stale ? "You changed things since — make it again to include them." : `Ready · ${secs(ex.length)} · ${mb(ex.size)}`)
              : ex.status === "failed" ? <span className="text-rose-600">{ex.error}</span>
                : hasReady ? "Joins your clips with captions and music into one video." : "Make at least one clip first."}
        </p>
      </div>
      <div className="flex flex-wrap gap-2">
        {ex.status === "ready" && ex.url && <>
          <button onClick={onWatch} data-testid="export-watch-btn" className="h-9 px-3 rounded-full border border-slate-200 text-xs text-slate-700 flex items-center gap-1.5 hover:border-slate-300"><Play size={13} /> Watch</button>
          <a href={`${assetUrl(ex.url)}?download=1`} data-testid="export-download-btn" className="h-9 px-4 rounded-full bg-slate-900 text-white text-xs font-medium flex items-center gap-1.5 hover:bg-slate-800 transition-colors"><Download size={13} /> Download</a>
        </>}
        <button onClick={make} disabled={busy || rendering || !hasReady} data-testid="export-make-btn"
          className="h-9 px-4 rounded-full bg-emerald-600 text-white text-xs font-medium flex items-center gap-1.5 hover:bg-emerald-700 transition-colors disabled:opacity-50">
          {busy || rendering ? <Loader2 size={13} className="animate-spin" /> : <Sparkles size={13} />} {ex.status === "ready" ? "Make again" : "Make video"}
        </button>
      </div>
    </section>
  );
};

export default ExportCard;
